import React, { useState } from "react";
import pdfIcon from "../assets/pdfIcon.png";
import downloadIcon from "../assets/downloadIcon.png";
import lockIcon from "../assets/lockIcon.png";
import { useAuth } from "../contexts/AuthContext";
import api from "../services/api";
import { useParams } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import DeleteButton from "./DeleteButton.jsx";
const PdfDownload = ({
  onUpload,
  onDownload,
  onDelete,
  isDownloadAvailable,
  isFileAvailable,
  isUploadDone,
  identifier,
  title,
}) => {
  const { user } = useAuth();
  const { id } = useParams();

  const url = window.location.href;

  const isOrderLoadPage = url.includes("/cargas/");

  const isOrderDetailsOrOrderLoadPage =
    url.includes("/pedidos/detalhes") ||
    (url.includes("/cargas/") && url.includes("/detalhes"));

  const isAdmin = user.accessType === "ADMIN";

  const [isDownloadEnabled, setIsDownloadEnabled] =
    useState(isDownloadAvailable);

  const handleToggleDownload = async () => {
    console.log("handle togle");
    if (!isAdmin && !onUpload) return;

    if (!isAdmin && isOrderDetailsOrOrderLoadPage) return;

    const newDownloadEnabled = !isDownloadEnabled;

    setIsDownloadEnabled(newDownloadEnabled);

    if (!onDownload) return;
    try {
      console.log("fiz o patch");
      await api.patch(
        isOrderLoadPage ? `/order-loads/${id}` : `/orders/${id}`,
        { [identifier]: newDownloadEnabled }
      );
    } catch (error) {
      console.log("Erro ao atualizar status do download: ", error);
    }
  };

  return (
    <div className="flex flex-col items-center p-4 rounded-lg w-full text-boldGray opacity-90">
      <div className="flex h-[48px]">
        <h2 className="font-bold mb-2 md:text-sm lg:text-base">
          {title || "PROFORMA INVOICE - ALVO"}
        </h2>
      </div>

      <div className="flex items-center rounded-lg shadow-lg w-full md:p-2 2xl:p-6 justify-between bg-[#E8E9EB]">
        <div>
          <img
            src={pdfIcon}
            alt="PDF icon"
            className="md:w-[30px] lg:w-[40px] xl:w-[50px] cursor-pointer"
            onClick={onDownload}
          />
        </div>
        <div className="md:text-xs lg:text-base md:ml-2">
          <p>
            {onUpload && !onDownload
              ? ""
              : (isFileAvailable && onDownload) || (isUploadDone && onDownload)
              ? "Arquivo disponível"
              : "Arquivo não disponível"}
          </p>
          <p className="font-bold text-center">
            {onDownload && !isFileAvailable && !isUploadDone
              ? ""
              : onDownload || (isUploadDone && isOrderDetailsOrOrderLoadPage)
              ? "Baixar arquivo"
              : "Adicionar arquivo"}
          </p>
        </div>
        <div>
          {isDownloadEnabled || isAdmin ? (
            <>
              <div className="flex gap-10 items-center justify-center">
                <button
                  type="button"
                  className="flex-shrink-0"
                  onClick={() =>
                    (onDownload && isFileAvailable && onDownload()) ||
                    document.getElementById(`fileInput-${identifier}`).click()
                  }
                >
                  <img
                    src={downloadIcon}
                    alt="Upload icon"
                    className="cursor-pointer"
                  />
                </button>
                {isFileAvailable && <DeleteButton onConfirm={onDelete} />}
              </div>
              <input
                type="file"
                id={`fileInput-${identifier}`}
                style={{ display: "none" }}
                accept="application/pdf"
                onChange={onUpload}
              />
            </>
          ) : (
            <img
              src={downloadIcon}
              alt="Download disabled"
              className="md:w-5 2xl:w-6 md:ml-2 opacity-50 cursor-not-allowed"
            />
          )}
        </div>
      </div>

      <div className="flex items-center justify-center mt-4">
        <div className="relative inline-flex">
          <button
            onClick={handleToggleDownload}
            type="button"
            className={`rounded-full w-10 h-5 p-1 flex items-center cursor-pointer ${
              isDownloadEnabled || isUploadDone
                ? "bg-orange-400"
                : "bg-gray-300"
            }`}
          >
            <div
              className={`rounded-full w-4 h-4 bg-white transition-transform ${
                isDownloadEnabled || isUploadDone
                  ? "transform translate-x-5"
                  : ""
              }`}
            ></div>
          </button>
          <img src={lockIcon} alt="Lock icon" className="ml-2 w-4 h-4" />
        </div>
      </div>
    </div>
  );
};

export default PdfDownload;
